module.exports = __webpack_public_path__ + "assets/img/kyyzk1.04403828.png";